<ng-template #content let-c="close" let-d="dismiss">
  <div class="lna-modal-header">
    <h4 class="modal-title" id="modal-basic-title">
      {{ 'components.mapModal.title' | translate }}
    </h4>
    <button class="btn-close" (click)="close()" type="button" aria-label="Close"></button>
  </div>
  <div class="lna-modal-body map-modal-body">
    <div
      class="map"
      [leafletOptions]="options"
      [leafletLayers]="marker ? [marker] : []"
      (leafletClick)="onMapClick($event)"
      style="width: 100%"
      leaflet></div>
  </div>
  <div class="lna-modal-footer">
    <button class="primary" [disabled]="isLoading" (click)="handleSave()" type="button">
      {{ 'components.mapModal.save' | translate }}
    </button>
    <button class="secondary" (click)="close()" type="button">
      {{ 'components.mapModal.cancel' | translate }}
    </button>
  </div>
</ng-template>

<button class="open-button" (click)="open(content)">
  {{ 'components.mapModal.markInMap' | translate }}
</button>
